import './../styles/user-details.scss';
import VisionApiPlansTemplate from './vision-api-plans-dialog.html';
import VisionApiPlansCtrl from './vision-api-plans-ctrl-dialog';


export default /* @ngInject */ class VisionApiUpgradeCtrl {
    constructor($timeout, $scope, $mdDialog, ProductsResource, PaymentProfileResource, $q, $log) {

        this.dependencies = {
            $mdDialog: $mdDialog,
            $q: $q,
            $log: $log,
            $scope: $scope,
            $timeout: $timeout
        };

        this.finalCopyToClipboardTxt = 'Key Copied !';
        this.initCopyToClipboardTxt = 'Copy to Clipboard';
        this.dependencies.$scope.copyToClipboardTxt = this.initCopyToClipboardTxt;
        this.$loadingPlans = true;
        this.productsResource = ProductsResource;
        this.paymentProfileResource = PaymentProfileResource;

        this.visionPlans = null;
        this.currentProduct = null;
        this.unsubscribed = null;
        this.isPlanUpgradeDisabled = null;

        this.usage = 0;
        this.limit = 0;

        this.client = {
            id: null,
            secret: null
        };

        const promises = {
            profile: this.paymentProfileResource.getProfile().$promise,
            plans: this.productsResource.api().$promise
        };

        this.dependencies.$q.all(promises).then((data) => {
            this.plans = data.plans;
            // index plans by Id
            let plans = {};
            this.groups = new Set();
            data.plans.forEach((item) => {
                plans[item.id] = item;
                if(item.group !== undefined) {
                    this.groups.add(item.group);
                }
            });

            //resolve product id to product object
            data.profile.subscribed_products.forEach((item) => {
                item.product_id = item.product;
                item.product = plans[item.product_id];
            });
            return data;

        }).then((data) => {
            this.profile = data.profile;
            this.currentProducts = [];
            if(this.profile.subscribed_products.length !== 0) {
                this.activeplans = true;

                for(let i=0; i<data.profile.subscribed_products.length; i++) {
                    let product = data.profile.subscribed_products[i];
                    this.currentProduct = product;
                    if(this.currentProduct.billing_completed) {
                        this.currentProduct.unsubscribed = true;
                    }
                    this.currentProduct.isPlanUpgradeDisabled = !product.is_upgrade_enabled;
                    this.currentProducts.push(this.currentProduct);
                    this.currentProduct.is_active = product.is_active;
                    const dateStringArr = new Date(product.end_date).toDateString().split(' ');
                    this.currentProduct.expires_at = dateStringArr.slice(1, dateStringArr.length).join(' ');
                }

                this.apiKeys = [];
                for(let product of this.currentProducts) {
                    product.$loadingApi = true;
                    this.productsResource.apiStatus({
                            groupId: product.product.group,
                            subscribedProductId: product.id
                            }).$promise.then((productData) => {
                        this.client.id = productData.client_id;
                        this.currentKey = {};
                        this.currentKey.usage = productData.used_today;
                        this.currentKey.client = this.client;
                        this.currentKey.name = productData.name;
                        this.currentKey.platform = productData.platform;
                        this.currentKey.description = productData.description;
                        this.currentKey.app_id = productData.app_id;
                        this.currentKey.client_id = productData.client_id;
                        this.currentKey.is_active = product.is_active;
                        angular.extend(product, this.currentKey);
                        product.$loadingApi = false;
                    }, () => {
                        product.$loadingApi = false;
                        this.currentKey = {};
                        this.currentKey.apikey = 'unable to fetch api key for user';
                        this.currentKey.usage = -1;
                        this.apiKeys.push(this.currentKey);
                        angular.extend(product, this.currentKey);
                    });
                }
                this.$loadingPlans = false;
            }
            else {
                this.activeplans = false;
                this.$loadingPlans = false;
            }
        });
    }

    getCopyButtonTitle(productName) {
        const copyButtonTitle = (productName === 'CV') ? 'API Key' : 'SDK License Key';
        return copyButtonTitle.toUpperCase();
    }

    getNextPlan(current, allPlans) {
        let currentIndex, nextIndex;
        currentIndex = allPlans.findIndex((plan) => {
            return current.id === plan.id;
        });
        nextIndex = (currentIndex + 1 < allPlans.length) ? currentIndex + 1 : currentIndex;
        return allPlans[nextIndex] && allPlans[nextIndex];
    }

    textCopied() {
        const deps = this.dependencies;
        const scope = deps.$scope;
        scope.copyToClipboardTxt = this.finalCopyToClipboardTxt;
        deps.$timeout(()=> {
            scope.copyToClipboardTxt = this.initCopyToClipboardTxt;
        }, 1000);
    }

    upgrade(currentProduct, event) {
        let currentProductPlans = this.plans.filter((plan) => plan.group === currentProduct.product.group);
        let dialog = {
            controller: VisionApiPlansCtrl,
            controllerAs: 'apiPlans',
            templateUrl: VisionApiPlansTemplate,
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                user: this.user,
                cvapi: {
                    current: currentProduct.product,
                    plans: currentProductPlans,
                    selected: this.getNextPlan(currentProduct.product, currentProductPlans),
                    billingCompleted: this.unsubscribed
                }
            }
        };

        this.dependencies.$mdDialog.show(dialog)
            .then((response) => {
                this.dependencies.$log.debug(response);
            });
    }
}



// WEBPACK FOOTER //
// ./user/visionapi/vision-api-upgrade-ctrl.js